import Keycloak from 'keycloak-js';
import { detectEnv } from '../detectEnv/detectEnv';

export const IS_TEST = window.location.href.includes('test');

export const KEYCLOAK_URI_TEST = 'https://test-sbercloud.sberbank-insurance.ru/sso';
export const KEYCLOAK_URI_PROD = 'https://sberbank-insurance.ru/sso';

export const KEYCLOAK_LOGOUT_URI_TEST = 'https://test-sbercloud.sberbank-insurance.ru/ipoteka';
export const KEYCLOAK_LOGOUT_URI_PROD = 'https://sberbank-insurance.ru/ipoteka';

const env = detectEnv();

export const keycloak = new Keycloak({
    url: env === 'prod' ? KEYCLOAK_URI_PROD : KEYCLOAK_URI_TEST, // ← Базовый URL Keycloak
    realm: 'proverka-statusa-zayavleniya', // ← Realm из URL
    clientId: 'ipoteka', // ← Client ID для продукта
});

export const AUTH_PROVIDERS = {
    esia: 'esia-identity-provider',
    sberId: 'sberid-identity-provider',
} as const;

export const getToken = (keycloak: Keycloak) => {
    return keycloak.token as string;
};
export const getAuthenticated = (keycloak: Keycloak) => {
    return keycloak.authenticated;
};
export const getTokenParsed = (keycloak: Keycloak) => {
    return keycloak.tokenParsed;
};
export const getIdentityProvider = (keycloak: Keycloak) => {
    return keycloak.tokenParsed?.identity_provider;
};
export const getExtSub = (keycloak: Keycloak) => {
    return keycloak.tokenParsed?.ext_sub;
};
export const getExtUuid = (keycloak: Keycloak) => {
    return keycloak.tokenParsed?.ext_uuid;
};
export const getIsAuthenticated = (keycloak: Keycloak) => {
    return keycloak.authenticated;
};
export const getIsAuthenticatedWithEsia = (keycloak: Keycloak) => {
    return keycloak.authenticated && keycloak.tokenParsed?.identity_provider === AUTH_PROVIDERS.esia;
};
export const getIsAuthenticatedWithSberId = (keycloak: Keycloak) => {
    return keycloak.authenticated && keycloak.tokenParsed?.identity_provider === AUTH_PROVIDERS.sberId;
};

export const SHOULD_AUTH_WITH_SBER_ID_COOKIE = 'shouldAuthWithSberId';
export const SHOULD_AUTH_WITH_ESIA_COOKIE = 'shouldAuthWithEsia';
export const SHOULD_SHOW_SECOND_FORM_COOKIE = 'shouldShowSecondForm';
